import { useEffect, useState } from 'react'
import { TelegramAuthData } from '../../shared/api/authApi.ts'
import { Spinner } from '../../shared/ui/spinner.tsx'

interface TelegramLoginButtonProps {
  botId: string
  onAuthSuccess: (userData: TelegramAuthData) => void
  onAuthFailure: () => void
  onClick?: () => void
  buttonText?: string
  className?: string
  outerLoading?: boolean
  type?: 'button' | 'icon'
}

const TelegramLoginCustom: React.FC<TelegramLoginButtonProps> = ({
  botId,
  onAuthSuccess,
  onAuthFailure,
  onClick,
  buttonText = 'Войти c Telegram',
  className = '',
  outerLoading = false,
  type = 'button',
}) => {
  const [scriptLoaded, setScriptLoaded] = useState(false)
  const [loading, setIsLoading] = useState(false)

  useEffect(() => {
    if (document.getElementById('telegram-login-script')) {
      setScriptLoaded(true)
      return
    }

    const script = document.createElement('script')
    script.id = 'telegram-login-script'
    script.src = 'https://telegram.org/js/telegram-widget.js'
    script.async = true

    script.onload = () => {
      setScriptLoaded(true)
    }

    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  const handleTelegramLogin = () => {
    setIsLoading(true)
    onClick?.()

    if (!scriptLoaded || !window.Telegram) {
      console.error('Telegram script not loaded yet')
      return
    }

    window.Telegram.Login.auth(
      { bot_id: botId, request_access: true },
      (data) => {
        if (!data) {
          onAuthFailure()
          setIsLoading(false)
          return
        }
        onAuthSuccess(data)
        setIsLoading(false)
      },
    )
  }

  const buttonContent =
    loading || outerLoading ? (
      <Spinner />
    ) : (
      <>
        <div className="flex size-32 items-center justify-center rounded-full pr-[3px]">
          <svg className="size-32" viewBox="0 0 24 24" fill="#ffffff">
            <path d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.71L12.6 16.3l-1.99 1.93c-.23.23-.42.42-.83.42z" />
          </svg>
        </div>
        {type === 'button' ? buttonText : ''}
      </>
    )

  return (
    <button
      onClick={handleTelegramLogin}
      disabled={!scriptLoaded || loading || outerLoading}
      className={`
        flex h-48 min-w-48 items-center   
        justify-center gap-8 
        rounded-full bg-[#54a9eb] font-medium
        text-white transition-colors hover:bg-[#4095d6]
        disabled:bg-[#54a9eb]
        ${className}
      `}
    >
      {buttonContent}
    </button>
  )
}

export default TelegramLoginCustom
